<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.password"
          type="password"
          label="Geslo *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.password.required || !$v.form.password.alphaNum || !$v.form.password.minLength || !$v.form.password.maxLength)"
        >
          <FormErrorsLine v-if="!$v.form.password.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.password.alphaNum" text="Dovoljene so le male črke, velike črke in številke" />
          <FormErrorsLine v-if="!$v.form.password.minLength || !$v.form.password.maxLength" text="Dolžina gesla mora biti med 6 in 20 znakov" />
        </FormErrors>
        <v-text-field
          v-model="form.password2"
          type="password"
          label="Ponovno geslo *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.password2.required || !$v.form.password2.alphaNum || !$v.form.password2.minLength || !$v.form.password2.maxLength || !$v.form.password2.sameAsPassword)"
        >
          <FormErrorsLine v-if="!$v.form.password2.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.password2.alphaNum" text="Dovoljene so le male črke, velike črke in številke" />
          <FormErrorsLine v-if="!$v.form.password2.minLength || !$v.form.password2.maxLength" text="Dolžina gesla mora biti med 6 in 20 znakov" />
          <FormErrorsLine v-if="!$v.form.password2.sameAsPassword" text="Gesli se ne ujemata" />
        </FormErrors>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required, sameAs, alphaNum, minLength, maxLength } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  data () {
    return {
      form: {
        password: null,
        password2: null
      }
    }
  },
  validations: {
    form: {
      password: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      password2: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20),
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
